import { Dexie } from 'dexie';

export const db = new Dexie('darfol_catalog');

db.version(1).stores({
    user: '++index',
    latest: '++index',
});

db.open().catch(function (err) {
    console.error (err.stack || err);
});